import request from '@/utils/request'
// 素材中心相关接口
// 绑定后台管理员和广告主
export function bindAdminAdvert(data = {}) {
  return request({
    url: '/marketing_assets/images',
    method: 'post',
    data: {
      path: '',
      description: '',
      type: 1 // 1图片 2视频
    }
  })
}
// 获取图片/视频素材列表
export function materialList(type, description = '', page = 1, page_size = 15) {
  if (description.length === 0) {
    return request({
      url: `/marketing_assets/source_materials?type=${type}&page=${page}&page_size=${page_size}`,
      method: 'get'
    })
  }
}
// 添加图片素材
export function picUpload(data = {}) {
  return request({
    url: `/marketing_assets/images`,
    method: 'post',
    data
  })
}

// 创建公共原生页
export function createNativePAGE(data = {}) {
  return request({
    url: `/marketing_assets/native_pages`,
    method: 'post',
    data
  })
}

// 获取素材列表
export function getMaterialList(params) {
  return request({
    url: `/marketing_assets/source_materials`,
    method: 'get',
    params
  })
}

// 添加素材
export function addpic(data = {}) {
  return request({
    url: `/marketing_assets/source_materials`,
    method: 'post',
    data
  })
}
